import { useRef, useState } from 'react';

export const useMainCategoryToggle = () => {
  const [isOpen, setOpen] = useState(false);
  const subRef = useRef(null);
  const arrowRef = useRef(null);

  const toggleSubCategory = (e) => {
    /**
     * 화살표 아이콘 클릭시에만 카테고리가 토글되도록 구현
     * */
    if (arrowRef.current?.contains(e.target)) {
      setOpen(!isOpen);
    }
  };

  return { arrowRef, subRef, isOpen, setOpen, toggleSubCategory };
};
